import { ColorV2 } from "config/colors";
import { ScheduleStatus } from "model/Schedule";
import { TFunction } from "i18next";

/** Resolve background + text colors for a schedule status. */
export const getBlockStatusStyling = (status: ScheduleStatus) => {
  switch (status) {
    case ScheduleStatus.ACCEPTED: {
      return {
        backgroundColor: ColorV2.SimflexityGreen,
        color: ColorV2.White,
      };
    }
    case ScheduleStatus.REPORTED: {
      return {
        backgroundColor: ColorV2.SimflexityGreen,
        color: ColorV2.White,
      };
    }
    case ScheduleStatus.SUBMITTED: {
      return {
        backgroundColor: ColorV2.SimflexityGreen,
        color: ColorV2.White,
      };
    }
    case ScheduleStatus.DECLINED: {
      return {
        backgroundColor: ColorV2.DeclinedRed,
        color: ColorV2.White,
      };
    }
    case ScheduleStatus.OPEN: {
      return {
        backgroundColor: ColorV2.NotFilledGrey,
        color: ColorV2.White,
      };
    }
    case ScheduleStatus.PENDING: {
      return {
        backgroundColor: ColorV2.OfferedYellow,
        color: ColorV2.Blue1,
      };
    }
    case ScheduleStatus.PLANNED_ABSENCE: {
      return {
        backgroundColor: ColorV2.AbsenceLightBlue,
        color: ColorV2.Blue1,
      };
    }
    case ScheduleStatus.UNDEFINED: {
      return {
        backgroundColor: ColorV2.NotFilledGrey,
        color: ColorV2.White,
      };
    }
    case ScheduleStatus.UNPLANNED_ABSENCE: {
      return {
        backgroundColor: ColorV2.UnplannedAbsenceYellow,
        color: ColorV2.Blue1,
      };
    }
    case ScheduleStatus.WITHDRAWN: {
      return {
        backgroundColor: ColorV2.WithdrawnPink,
        color: ColorV2.Blue1,
      };
    }
    default: {
      return {
        backgroundColor: ColorV2.NotFilledGrey,
        color: ColorV2.White,
      };
    }
  }
};

/** Resolve the translated label for a schedule status. */
export const getBlockStatusText = (status: ScheduleStatus, t: TFunction) => {
  switch (status) {
    case ScheduleStatus.ACCEPTED: {
      return t("Schedule.Booked");
    }
    //To handle timereports
    case ScheduleStatus.REPORTED: {
      return t("Schedule.Booked");
    }
    //To handle timereports
    case ScheduleStatus.SUBMITTED: {
      return t("Schedule.Booked");
    }
    case ScheduleStatus.DECLINED: {
      return t("Schedule.Declined");
    }
    case ScheduleStatus.OPEN: {
      return t("Schedule.Notfilled");
    }
    case ScheduleStatus.PENDING: {
      return t("Schedule.Offered");
    }
    case ScheduleStatus.PLANNED_ABSENCE: {
      return t("Schedule.PlannedAbsence");
    }
    case ScheduleStatus.UNDEFINED: {
      return t("Schedule.Undefined");
    }
    case ScheduleStatus.UNPLANNED_ABSENCE: {
      return t("Schedule.UnplannedAbsence");
    }
    case ScheduleStatus.WITHDRAWN: {
      return t("Schedule.Withdrawn");
    }
    default: {
      return t("Schedule.Notfilled");
    }
  }
};

/** Resolve label + description text for the shift details status banner. */
export const getShiftDetailTexts = (
  status: ScheduleStatus,
  t: TFunction,
): { label: string; text: string } => {
  switch (status) {
    case ScheduleStatus.ACCEPTED: {
      return {
        label: t("Schedule.Booked"),
        text: t("Schedule.BookedStatusText"),
      };
    }
    case ScheduleStatus.REPORTED: {
      return {
        label: t("Schedule.Booked"),
        text: t("Schedule.BookedStatusText"),
      };
    }
    case ScheduleStatus.SUBMITTED: {
      return {
        label: t("Schedule.Booked"),
        text: t("Schedule.BookedStatusText"),
      };
    }
    case ScheduleStatus.DECLINED: {
      return {
        label: t("Schedule.Declined"),
        text: t("Schedule.DeclinedStatusText"),
      };
    }
    case ScheduleStatus.OPEN: {
      return {
        label: t("Schedule.Notfilled"),
        text: t("Schedule.NotfilledStatusText"),
      };
    }
    case ScheduleStatus.PENDING: {
      return {
        label: t("Schedule.Offered"),
        text: t("Schedule.OfferedStatusText"),
      };
    }
    case ScheduleStatus.PLANNED_ABSENCE: {
      return {
        label: t("Schedule.PlannedAbsence"),
        text: t("Schedule.PlannedAbsenceStatusText"),
      };
    }
    case ScheduleStatus.UNDEFINED: {
      return {
        label: t("Schedule.Notfilled"),
        text: t("Schedule.NotfilledStatusText"),
      };
    }
    case ScheduleStatus.UNPLANNED_ABSENCE: {
      return {
        label: t("Schedule.UnplannedAbsence"),
        text: t("Schedule.UnplannedAbsenceStatusText"),
      };
    }
    case ScheduleStatus.WITHDRAWN: {
      return {
        label: t("Schedule.Withdrawn"),
        text: t("Schedule.WithdrawnStatusText"),
      };
    }
    default: {
      return {
        label: t("Schedule.Notfilled"),
        text: t("Schedule.NotfilledStatusText"),
      };
    }
  }
};
